// extracted by mini-css-extract-plugin
module.exports = {"splash-page":"splash_page_splash-page__382WM","hero":"splash_page_hero__15gyK"};